import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION, GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION, GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATIONS, SAVE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION } from "../../../data/definitions/discount-group-product-group-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupProductGroupRelationMutation, DeleteDiscountGroupProductGroupRelationMutationVariables, DeletionResponse, DiscountGroupProductGroupRelation, DiscountGroupProductGroupRelationInput, DiscountGroupProductGroupRelationSearchInput, GetDiscountGroupProductGroupRelationQuery, GetDiscountGroupProductGroupRelationQueryVariables, GetDiscountGroupProductGroupRelationsQuery, GetDiscountGroupProductGroupRelationsQueryVariables, SaveDiscountGroupProductGroupRelationMutation, SaveDiscountGroupProductGroupRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupProductGroupRelationService extends BaseListService<DiscountGroupProductGroupRelation> implements ICRUD<DiscountGroupProductGroupRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupProductGroupRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupProductGroupRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupProductGroupRelationSearchInput): QueryResult<GetDiscountGroupProductGroupRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupProductGroupRelationsQuery, GetDiscountGroupProductGroupRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupProductGroupRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupProductGroupRelationQuery, GetDiscountGroupProductGroupRelationQueryVariables>(
            GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupProductGroupRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupProductGroupRelation as DiscountGroupProductGroupRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupProductGroupRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupProductGroupRelation as DiscountGroupProductGroupRelation);
    }

    async saveItem(item: DiscountGroupProductGroupRelationInput): Promise<DiscountGroupProductGroupRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.PRODUCTGROUP;

        let validated = await this.systemService.validateObject<DiscountGroupProductGroupRelationInput>(item, "DiscountGroupProductGroupRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupProductGroupRelationMutation, SaveDiscountGroupProductGroupRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupProductGroupRelation as DiscountGroupProductGroupRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupProductGroupRelationMutation, DeleteDiscountGroupProductGroupRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupProductGroupRelation;
    }
}